<template>
  <div class="flex items-center space-x-3.5">
    <a
      v-for="(link, index) in smLinks"
      :key="index"
      target="_blank"
      :href="link.url"
    >
      <img
        class="h-[18px] w-[18px] lg:h-[23px] lg:w-[23px]"
        :src="icon(link.icon)"
        :alt="link.name"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "FooterSocialMedia",
  props: {
    isGetLabTest: {
      type: [Boolean],
      default: false,
    },
  },
  data() {
    return {
      getLabTestSmLinks: [
        {
          name: this.$t("who_we_are.footer.social_media.facebook"),
          url: "https://www.facebook.com/getlabtest",
          icon: "fb.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.instagram"),
          url: "https://www.instagram.com/getlabtest/",
          icon: "insta.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.twitter"),
          url: "https://twitter.com/GetLabTest",
          icon: "x.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.linkedIn"),
          url: "https://www.linkedin.com/company/getlabtest/",
          icon: "linkedin.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.tiktok"),
          url: "https://www.tiktok.com/@getlabtest",
          icon: "tiktok.png",
        },
      ],
      diaguSmLinks: [
        {
          name: this.$t("who_we_are.footer.social_media.facebook"),
          url: "https://www.facebook.com/diagu.uk",
          icon: "fb.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.instagram"),
          url: "https://www.instagram.com/diagu_com/",
          icon: "insta.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.twitter"),
          url: "https://twitter.com/diagu_com",
          icon: "x.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.linkedIn"),
          url: "https://www.linkedin.com/company/diagu-uk/",
          icon: "linkedin.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.crunchbase"),
          url: "https://www.crunchbase.com/organization/diagu",
          icon: "crunchbase.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.angelists"),
          url: "https://angel.co/company/diagu",
          icon: "angelist.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.medium"),
          url: "https://medium.com/@diagu ",
          icon: "medium.png",
        },
        {
          name: this.$t("who_we_are.footer.social_media.f6s"),
          url: "https://www.f6s.com/company/diagu ",
          icon: "f6s.png",
        },
      ],
    };
  },
  computed: {
    smLinks() {
      return this.isGetLabTest ? this.getLabTestSmLinks : this.diaguSmLinks;
    },
  },
  methods: {
    icon(name) {
      return require(`@/assets/images/base/social-icons/${name}`);
    },
  },
};
</script>
